'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clampPositive = exports.divideBy = undefined;

var _ramda = require('ramda');

// eslint-disable-next-line import/prefer-default-export
var divideBy = exports.divideBy = (0, _ramda.flip)(_ramda.divide);

var clampPositive = exports.clampPositive = (0, _ramda.clamp)(0, Number.POSITIVE_INFINITY);


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/numbers.js
// module id = 682
// module chunks = 168707334958949